export default "<ion-button (click)=\"goBack()\">\n  <ion-icon name=\"arrow-back\" slot=\"icon-only\"></ion-icon>\n</ion-button>"